import React, { useEffect, useState, FormEvent } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Formulario, { FormField } from "../../../components/Formulario";
import { getTipoById, updateTipo } from "../../../api/tipoApi";

const EditarTipo: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [nomeTipo, setNomeTipo] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [updating, setUpdating] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTipo = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const tipoData = await getTipoById(token, id!);
        setNomeTipo(tipoData.nome_tipo);
      } catch (error) {
        toast.error("Erro ao buscar tipo!");
        console.error("Erro ao buscar tipo:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTipo();
  }, [id]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setUpdating(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }

      await updateTipo(token, id!, {
        nome_tipo: nomeTipo,
      });
      toast.success("Tipo atualizado com sucesso!");
      navigate("/tipos");
    } catch (error) {
      toast.error("Erro ao atualizar Tipo!");
      console.error("Erro ao atualizar Tipo:", error);
    } finally {
      setUpdating(false);
    }
  };

  const handleBack = () => {
    navigate("/tipos");
  };

  const fields: FormField[] = [
    {
      label: "Nome do Tipo",
      type: "text",
      value: nomeTipo,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNomeTipo(e.target.value),
    },
  ];

  return (
    <Formulario
      title="Editar Tipo"
      fields={fields}
      onSubmit={handleSubmit}
      onBack={handleBack}
      loading={loading || updating}
    />
  );
};

export default EditarTipo;
